import { render, staticRenderFns } from "./editUnfreezeReason.vue?vue&type=template&id=00ab7954"
import script from "./editUnfreezeReason.vue?vue&type=script&lang=js"
export * from "./editUnfreezeReason.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports